import { render, staticRenderFns } from "./modelling.vue?vue&type=template&id=e9384866"
import script from "./modelling.vue?vue&type=script&lang=js"
export * from "./modelling.vue?vue&type=script&lang=js"
import style0 from "./modelling.vue?vue&type=style&index=0&id=e9384866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports